import { useDispatch, useSelector } from "react-redux";
import { Message, Segment, TransitionablePortal } from "semantic-ui-react";
import { HideToastMessage } from "../../actions/toastActions";
import { AppState } from "../../store/configureStore";

export const ToastMessage = () => {
    const dispatch = useDispatch();
    const { showMessage, text, success } = useSelector((state: AppState) => state.toast);

    return (
        <TransitionablePortal
            id={`transitionable-portal-toastMessage-${text}`}
            open={showMessage}
            onClose={() => dispatch(HideToastMessage())}
            transition={{ animation: "zoom", duration: 300 }}
            closeOnDocumentClick={false}
        >
            <Segment id={`toast-container-toastMessage-${text}`} basic className="toast-container">
                <Message id={`message-toastMessage-${text}`} compact className="toast-message" positive={success} negative={!success}>
                    {text}
                </Message>
            </Segment>
        </TransitionablePortal>
    );
};
